import { useEffect, useRef } from 'react';

export const usePrevious = <T>(value: T, shouldSkipUpdate = false): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    if (shouldSkipUpdate) {
      return;
    }

    ref.current = value;
  });

  return ref.current;
};
